import createSvgIcon from '@mui/icons-material/utils/createSvgIcon'
import React from 'react'
// viewBox="0 0 14 14.5"

const SaveForLaterIcon = createSvgIcon(
  <>
    <path
      xmlns='http://www.w3.org/2000/svg'
      d='M12.5,7.2V3.6l-2.1-2.1H1.5v11h5V14h-5c-0.4,0-0.8-0.1-1.1-0.4C0.1,13.3,0,12.9,0,12.5v-11c0-0.4,0.1-0.8,0.4-1.1  C0.7,0.1,1.1,0,1.5,0H11l3,3v4.2 M1.5,1.5v11V1.5z M2.5,5.5h7v-3h-7V5.5z'
    />
    <polygon
      xmlns='http://www.w3.org/2000/svg'
      points='10.9,14.5 13.9,11.5 12.8,10.4 11.7,11.6 11.7,8.5 10.2,8.5 10.2,11.6 9,10.4 7.9,11.5 '
    />
    <circle xmlns='http://www.w3.org/2000/svg' cx='7.3' cy='8.5' r='2' />
  </>,
  'SaveForLaterIcon'
)

export default SaveForLaterIcon
